.f4{color:var(--gray-700);}